// 🔴 L2 (N°876) — saisie d'un SITE : le lieu RÉEL d'une affaire.
// ⛔ Aucun site inventé : l'adresse et la ville sont obligatoires, rien n'est
// déduit du client.
// 🔴 N°915-A — CONTRAT CORE DE L'ADRESSE : ce formulaire ⛔ n'envoie JAMAIS le CP ni
//    la ville DANS `adresse`. La saisie libre (et le collage) donnent le libellé
//    entier — `normaliserAdresse` le découpe, source UNIQUE pour tout OmniHub.
import { useState } from "react";
import { normaliserAdresse } from "../../../utils/clientFormat";

const CHAMP = { height: 36, borderRadius: 8, padding: "0 10px", width: "100%",
                border: "0.5px solid var(--oh-border)",
                background: "var(--oh-bg-surface)", color: "var(--oh-text)" };

export function SiteForm({ onValider, onAnnuler, occupe = false, libelleBouton = "Créer le site" }) {
  const [v, setV] = useState({ nom_site: "", adresse: "", code_postal: "", ville: "" });
  const champ = (cle, ph) => (
    <input value={v[cle]} placeholder={ph} aria-label={ph} data-testid={`site-${cle}`}
           onChange={(ev) => setV((x) => ({ ...x, [cle]: ev.target.value }))} style={CHAMP} />
  );
  const complet = v.adresse.trim() && v.ville.trim();
  return (
    <div className="space-y-2" data-testid="site-form">
      {champ("nom_site", "Nom du site (ex. Résidence Les Tilleuls — bât. B)")}
      {champ("adresse", "Adresse du site")}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        {champ("code_postal", "Code postal")}
        <div className="sm:col-span-2">{champ("ville", "Ville")}</div>
      </div>
      <div className="flex gap-2">
        <button type="button" disabled={!complet || occupe} data-testid="site-valider"
                onClick={() => {
                  // 🔑 Le découpage se fait ICI, à la frontière d'écriture : l'utilisateur
                  //    tape comme il veut, la BASE reçoit le contrat.
                  const n = normaliserAdresse(v);
                  onValider({ nom_site: v.nom_site.trim() || undefined,
                              adresse: n.adresse,
                              code_postal: n.code_postal || undefined,
                              ville: n.ville });
                }}
                className="rounded-lg px-3 text-sm disabled:opacity-60"
                style={{ height: 36, background: "var(--oh-accent-solid)",
                         color: "var(--oh-accent-contrast)" }}>
          {libelleBouton}
        </button>
        {onAnnuler && (
          <button type="button" onClick={onAnnuler} className="rounded-lg px-3 text-sm"
                  style={{ height: 36, background: "transparent",
                           border: "0.5px solid var(--oh-border)",
                           color: "var(--oh-text-secondary)" }}>
            Annuler
          </button>
        )}
      </div>
    </div>
  );
}

export default SiteForm;
